import { Component, inject, OnInit,Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Mdladdproduct } from '../../components/mdl-add-product/mdl-add.product';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api'; 
import { CommonModule, CurrencyPipe } from '@angular/common';



@Component({
  selector: 'app-version-budget',
  imports: [CurrencyPipe,CommonModule],
  templateUrl: './budget-version-table.html',
  styleUrl: './budget-version-table.css'
})
export class BudgetVersionTable {
        presupuesto_id: string = '';
        versiones: any[] = [];
    isLoading: boolean = true;
    errorMessage: string = '';

    constructor(private api: Api, private route: ActivatedRoute){}


 ngOnInit(): void {
    this.presupuesto_id = this.route.snapshot.paramMap.get('id') || '';
    console.log('ID del presupuesto:', this.presupuesto_id);

    if (this.presupuesto_id) {
      this.api.getBudgetVersions({ presupuesto_id: this.presupuesto_id }).subscribe({
        next: (data: any) => this.versiones = data.versiones,
        error: (err) => console.error(err)
      });
    }
  }
  }



















